import React from 'react';

import { Title, Text, TitleProps, TextProps } from '@soluto-design/react';

import { Button, ButtonProps } from '@soluto-design/react';

import cls from '@soluto-design/styles/cls';

export interface BlockTitleSmallProps {
    preTitle?: string;
    preTitleTag?: TextProps['component'];
    title: string;
    titleTag?: TitleProps['component'];
    text?: string;
    cta?: ButtonProps;
}

export default function BlockTitleSmall({
    preTitle,
    preTitleTag = 'p',
    title,
    titleTag = 'h3',
    text,
    cta,
}: BlockTitleSmallProps) {
    return (
        <>
            {!!preTitle && (
                <Text
                    component={preTitleTag}
                    className="text-c100 font-regular text-text-primary pb-lg uppercase">
                    {preTitle}
                </Text>
            )}
            {!!title && (
                <Title
                    isHtml
                    component={titleTag}
                    className={cls('font-regular text-h300 text-text-primary')}>
                    {title}
                </Title>
            )}
            {!!text && (
                <Text
                    isHtml
                    component="div"
                    className={cls(
                        'font-regular text-b200 text-text-secondary pt-lg md:pr-xxxl',
                    )}>
                    {text}
                </Text>
            )}
            {!!cta && (
                <Button
                    variant="secondary"
                    size="large"
                    className="mt-xxl"
                    rightIcon="arrow-direction--type-right"
                    {...cta}
                />
            )}
        </>
    );
}
